@if (downloadService.downloadsListNumber() > 0) {
  <mat-list-item (keyDown)="(null)" (click)="openDownloadsPanel()">
    <div class="flex flex-row items-center">
      <div class="w-6 h-6 mx-[4px]">
        @if (downloadService.isAnyDownloadInProgress()) {
          <div
            class="w-full h-full min-w-[24px] min-h-[24px] animate-spin"
            [ngStyle]="{
              'background-image': progressIcon,
            }"
          ></div>
        } @else {
          <span class="material-icons-outlined animate-pulse blue-theme-text-2">
            cloud_download
          </span>
        }
      </div>
      @if (expanded) {
        <span>
          {{
            downloadService.isAnyDownloadInProgress()
              ? 'Download in progress!'
              : 'All downloads ready!'
          }}
        </span>
      }
    </div>
  </mat-list-item>
}

<ng-template #downloadsManagementDialog>
  <div class="space-y-4 flex flex-col overflow-y-auto">
    @if (downloadService.downloadsList().length > 0) {
      <span class="font-semibold p-1">Download management</span>
      @for (download of downloadService.downloadsList(); track $index) {
        <div
          class="flex items-center justify-between p-4 theme-bg-2 rounded-lg shadow-sm"
        >
          <div class="flex items-center space-x-4">
            <div class="row items-center mr-[5px]">
              @if (download.status === 'PENDING') {
                <span class="material-icons-outlined text-blue-500"
                  >cloud_download</span
                >
              } @else if (download.status === 'COMPLETED') {
                <span class="material-icons-outlined text-green-500"
                  >check_circle</span
                >
              } @else if (download.status === 'FAILED') {
                <span class="material-icons-outlined text-red-500">error</span>
              }
            </div>

            <div class="flex-1">
              <div class="font-semibold text-lg">
                {{ download.file?.filename || 'Untitled' }}
              </div>
              <div
                [ngClass]="{
                  'text-red-500': download.status === 'FAILED',
                  'text-green-500': download.status === 'COMPLETED',
                  'text-blue-500': download.status === 'PENDING',
                }"
                class="text-sm"
              >
                {{ download.status }}
              </div>

              <div class="text-xs text-gray-400 mt-1 truncate">
                ID: {{ download.id }}
              </div>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            @if (download.status === 'PENDING') {
              <div class="relative w-16 h-16 mx-auto overflow-hidden">
                <div
                  class="absolute top-0 left-0 w-full h-full rounded-full border-4 border-blue-500 animate-spin"
                  style="
                    border-top-color: transparent;
                    border-right-color: transparent;
                  "
                ></div>

                <div
                  class="absolute top-0 left-0 w-full h-full flex justify-center items-center text-sm font-semibold text-blue-500"
                >
                  {{ download.progress || 0 }}%
                </div>
              </div>

              @if (download?.id) {
                <div class="w-10 h-10 flex items-center justify-center">
                  @if (isCancelling(download.id)) {
                    <mat-spinner diameter="20"></mat-spinner>
                  } @else {
                    <button
                      mat-icon-button
                      (click)="cancelDownload(download.id)"
                      class="!text-red-500 p-2 material-icons-outlined"
                      title="Cancel download"
                      [attr.aria-label]="'Cancel download ' + download.id"
                    >
                      cancel
                    </button>
                  }
                </div>
              }
            }

            @if (download.status === 'COMPLETED') {
              <button
                mat-icon-button
                (click)="downloadElement(download.id)"
                class="!text-blue-500 p-2 material-icons-outlined"
              >
                download
              </button>
            }

            @if (download.status !== 'PENDING') {
              <button
                mat-icon-button
                class="!text-red-500 p-2 material-icons-outlined"
                (click)="deleteDownload(download.id)"
              >
                delete
              </button>
            }
          </div>
        </div>
      }
    } @else {
      <div class="text-center text-gray-400">No downloads in progress</div>
    }
  </div>
</ng-template>
